import React, { Fragment, useEffect, useRef, useState } from 'react';
import AntAPI from '../../utils/AntAPI';
import AntLocalization from '../../utils/AntLocalization';

var pollAPI = null;
function getAPI() {
    if (!pollAPI) pollAPI = new AntAPI('ai', 'AIVoucherAnalysis');
    return pollAPI;
}

function IconCheck2() {
    return (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    );
}

// Map BE-reported current_phase string to step index (1-based).
// BE emits a small enum: 'uploaded' | 'ocr' | 'extract' | 'validate' | 'review'
// (plus free-form fallbacks). 'uploaded' means upload finished, OCR starting → step 2.
function stageToIndex(label) {
    if (!label) return 1;
    var s = String(label).toLowerCase();
    if (s.indexOf('uploaded') >= 0) return 2;
    if (s.indexOf('upload') >= 0 || s.indexOf('tải') >= 0) return 1;
    if (s.indexOf('ocr') >= 0 || s.indexOf('nhận diện') >= 0 || s.indexOf('recognize') >= 0) return 2;
    if (s.indexOf('extract') >= 0 || s.indexOf('bóc') >= 0) return 3;
    if (s.indexOf('valid') >= 0 || s.indexOf('resolve') >= 0 || s.indexOf('review') >= 0 || s.indexOf('kiểm tra') >= 0 || s.indexOf('khớp') >= 0) return 4;
    return 2;
}

var STEPS = [
    { label: { vi: 'Tải tài liệu lên', en: 'Upload document', fr: 'Envoyer le document', es: 'Subir documento', id: 'Unggah dokumen', ja: '文書をアップロード', zh: '上传文档', ko: '문서 업로드', hi: 'दस्तावेज़ अपलोड करें', ar: 'رفع المستند' }, hint: { vi: 'Đã nhận tài liệu', en: 'Document received', fr: 'Document reçu', es: 'Documento recibido', id: 'Dokumen diterima', ja: '文書を受信しました', zh: '已收到文档', ko: '문서 수신 완료', hi: 'दस्तावेज़ मिल गया', ar: 'تم استلام المستند' } },
    { label: { vi: 'Nhận diện văn bản (OCR)', en: 'Text recognition (OCR)', fr: 'Lecture du texte (OCR)', es: 'Lectura de texto (OCR)', id: 'Pengenalan teks (OCR)', ja: '文字認識 (OCR)', zh: '文字识别 (OCR)', ko: '문자 인식 (OCR)', hi: 'टेक्स्ट पहचान (OCR)', ar: 'التعرف على النص (OCR)' }, hint: { vi: 'Đọc nội dung tài liệu', en: 'Reading document content', fr: 'Lecture du contenu du document', es: 'Leyendo el contenido', id: 'Membaca isi dokumen', ja: '文書の内容を読み取り中', zh: '正在读取文档内容', ko: '문서 내용 읽는 중', hi: 'दस्तावेज़ पढ़ा जा रहा है', ar: 'قراءة محتوى المستند' } },
    { label: { vi: 'Bóc tách thông tin chứng từ', en: 'Extract voucher info', fr: 'Extraction des infos du document', es: 'Extraer datos del comprobante', id: 'Ekstrak info dokumen', ja: '伝票情報を抽出', zh: '提取单据信息', ko: '전표 정보 추출', hi: 'वाउचर जानकारी निकालना', ar: 'استخراج بيانات المستند' }, hint: { vi: 'Đang tìm: mã tham chiếu, ngày, khách hàng, danh sách sản phẩm…', en: 'Searching: reference, date, customer, items…', fr: 'Recherche : référence, date, client, liste d’articles…', es: 'Buscando: referencia, fecha, cliente, lista de artículos…', id: 'Mencari: referensi, tanggal, pelanggan, daftar item…', ja: '検索中: 参照番号、日付、顧客、商品リスト…', zh: '正在查找：参考号、日期、客户、商品列表…', ko: '검색 중: 참조번호, 날짜, 고객, 품목 목록…', hi: 'खोज रहे हैं: संदर्भ, तारीख, ग्राहक, आइटम सूची…', ar: 'جارٍ البحث: المرجع، التاريخ، العميل، قائمة الأصناف…' } },
    { label: { vi: 'Kiểm tra & khớp danh mục', en: 'Validate & match master', fr: 'Contrôle & rapprochement', es: 'Validar y cotejar catálogo', id: 'Validasi & cocokkan master', ja: '検証とマスタ照合', zh: '校验并匹配主数据', ko: '검증 및 마스터 대조', hi: 'जाँच और मास्टर मिलान', ar: 'التحقق والمطابقة مع القائمة' }, hint: { vi: 'Đối chiếu sản phẩm, khách hàng với hệ thống', en: 'Matching items, customers with master data', fr: 'Rapprochement des articles et clients avec le système', es: 'Cotejando artículos y clientes con el sistema', id: 'Mencocokkan item, pelanggan dengan sistem', ja: '商品・顧客をシステムと照合中', zh: '正在将商品、客户与系统比对', ko: '품목, 고객을 시스템과 대조 중', hi: 'आइटम, ग्राहक का सिस्टम से मिलान', ar: 'مطابقة الأصناف والعملاء مع النظام' } }
];

export default function Stage2Processing(props) {
    var [elapsed, setElapsed] = useState(0);
    var [activeStep, setActiveStep] = useState(1);
    var [tokensIn, setTokensIn] = useState(null);
    var [tokensOut, setTokensOut] = useState(null);
    var [fileName, setFileName] = useState(null);
    var [fileSize, setFileSize] = useState(null);
    var timerRef = useRef(null);
    var pollRef = useRef(null);
    var doneRef = useRef(false);
    // analysisIdRef giữ id hiện tại để socket listener đọc được giá trị mới nhất
    // mà KHÔNG cần re-register. BE chạy đồng bộ trong analyzeUpload → Stage2 mount
    // với analysisId=null suốt thời gian pipeline chạy. Listener phải có sẵn từ
    // mount đầu tiên, sau đó tự "khoá" vào id qua event 'started' đầu tiên.
    var analysisIdRef = useRef(props.analysisId || null);

    useEffect(function () {
        timerRef.current = setInterval(function () { setElapsed(function (x) { return x + 1; }); }, 1000);

        function poll() {
            var aid = analysisIdRef.current;
            if (doneRef.current || !aid) {
                // Chưa có id → thử lại sau. analysisIdRef sẽ được set khi prop
                // analysisId thay đổi hoặc qua event 'started'.
                if (!doneRef.current) pollRef.current = setTimeout(poll, 1500);
                return;
            }
            var api = getAPI();
            api.post('/' + api.routeURL + '/detail', { id: aid }, function (resp) {
                if (doneRef.current) return;
                var data = (resp && resp.data) || resp || {};
                var phase = data.current_phase || data.stage;
                if (phase) setActiveStep(stageToIndex(phase));
                if (data.tokens_input != null) setTokensIn(data.tokens_input);
                if (data.tokens_output != null) setTokensOut(data.tokens_output);
                if (data.source_doc_name && !fileName) setFileName(data.source_doc_name);
                if (data.source_doc_size && !fileSize) setFileSize(data.source_doc_size);
                if (data.analysis_status === 'Done') {
                    doneRef.current = true;
                    if (props.onDone) props.onDone(data);
                    return;
                }
                if (data.analysis_status === 'Failed') {
                    doneRef.current = true;
                    if (props.onFailed) props.onFailed(data);
                    return;
                }
                pollRef.current = setTimeout(poll, 2000);
            });
        }

        pollRef.current = setTimeout(poll, 1500);

        // Socket listener — phase update tới ngay, không phải đợi poll. BE phát
        // 'AIVoucherAnalysis-started' (sau actionCreate, có analysis_id) +
        // 'AIVoucherAnalysis-phase' mỗi bước (extract/resolve/validate/review) +
        // 'AIVoucherAnalysis-done'/'-failed' khi kết thúc.
        // QUAN TRỌNG: register NGAY khi mount (kể cả khi analysisId chưa có) vì
        // pipeline chạy đồng bộ trong analyzeUpload → nếu chờ analysisId sẽ
        // miss event 'started' và toàn bộ phase events.
        var socketKey = null;
        if (props.session && typeof props.session.registerSocketListener === 'function') {
            socketKey = 'Stage2Processing-' + (props.analysisId || 'pending');
            var onSocketReceived = function (msg) {
                if (!msg || !msg.event) return false;
                if (String(msg.event).indexOf('AIVoucherAnalysis-') !== 0) return false;
                var p = msg.data || {};
                var curId = analysisIdRef.current;
                if (curId) {
                    // ID 18 ký tự vượt JS safe integer → so sánh string để giữ precision
                    if (String(p.analysis_id) !== String(curId)) return false;
                } else {
                    // Chưa khoá id → chấp nhận event 'started' đầu tiên có
                    // analysis_id để khoá vào.
                    if (msg.event === 'AIVoucherAnalysis-started' && p.analysis_id) {
                        analysisIdRef.current = p.analysis_id;
                    } else {
                        return false;
                    }
                }
                if (doneRef.current) return true;
                if (p.current_phase) setActiveStep(stageToIndex(p.current_phase));
                if (p.analysis_status === 'Done' || msg.event === 'AIVoucherAnalysis-done') {
                    var api = getAPI();
                    api.post('/' + api.routeURL + '/detail', { id: analysisIdRef.current }, function (resp) {
                        if (doneRef.current) return;
                        doneRef.current = true;
                        var data = (resp && resp.data) || resp || {};
                        if (props.onDone) props.onDone(data);
                    });
                } else if (p.analysis_status === 'Failed' || msg.event === 'AIVoucherAnalysis-failed') {
                    doneRef.current = true;
                    if (props.onFailed) props.onFailed(p);
                }
                return true;
            };
            props.session.registerSocketListener(onSocketReceived, socketKey);
        }

        return function () {
            doneRef.current = true;
            if (timerRef.current) clearInterval(timerRef.current);
            if (pollRef.current) clearTimeout(pollRef.current);
            if (socketKey && props.session && typeof props.session.clearSocketListener === 'function') {
                props.session.clearSocketListener(socketKey);
            }
        };
    }, []);

    // Khi prop analysisId xuất hiện (Stage1 callback gọi onAnalyzed → cha set
    // analysisId), đồng bộ vào ref để poll dùng được id đó. Listener đã chạy
    // sẵn từ mount nên không cần re-register.
    useEffect(function () {
        if (props.analysisId && analysisIdRef.current !== props.analysisId) {
            analysisIdRef.current = props.analysisId;
        }
    }, [props.analysisId]);

    var mm = String(Math.floor(elapsed / 60)).padStart(2, '0');
    var ss = String(elapsed % 60).padStart(2, '0');

    function stepClass(idx) {
        if (idx < activeStep) return 's2-step is-done';
        if (idx === activeStep) return 's2-step is-active';
        return 's2-step is-pending';
    }
    function stepIcon(idx) {
        if (idx < activeStep) return <div className="s2-step-ico"><IconCheck2 /></div>;
        if (idx === activeStep) return <div className="s2-step-ico"><div className="spinner on-blue" /></div>;
        return <div className="s2-step-ico">{idx}</div>;
    }
    function stepRight(idx) {
        if (idx < activeStep) return <div className="s2-step-right">{AntLocalization.translateText({ vi: 'xong', en: 'done', fr: 'fini', es: 'listo', id: 'selesai', ja: '完了', zh: '完成', ko: '완료', hi: 'पूर्ण', ar: 'تم' })}</div>;
        if (idx === activeStep) return <div className="s2-step-right"><div className="spinner" />{AntLocalization.translateText({ vi: 'đang chạy', en: 'running', fr: 'en cours', es: 'en curso', id: 'berjalan', ja: '実行中', zh: '进行中', ko: '실행 중', hi: 'चल रहा है', ar: 'جارٍ' })}</div>;
        return <div className="s2-step-right">—</div>;
    }

    var modeLabel = props.mode === 'Quick'
        ? AntLocalization.translateText({ vi: 'Nhanh', en: 'Quick', fr: 'Rapide', es: 'Rápido', id: 'Cepat', ja: '高速', zh: '快速', ko: '빠름', hi: 'तेज़', ar: 'سريع' })
        : props.mode === 'Deep'
            ? AntLocalization.translateText({ vi: 'Chuyên sâu', en: 'Deep', fr: 'Approfondi', es: 'Profundo', id: 'Mendalam', ja: '詳細', zh: '深度', ko: '심층', hi: 'गहन', ar: 'متعمق' })
            : 'Standard';

    return (
        <div className="s2 s2-center">
            <div className="s2-hero">
                <div className="s2-doc-thumb">
                    <div className="l" /><div className="l" /><div className="l" /><div className="l" />
                    <div className="l" /><div className="l" /><div className="l" /><div className="l" />
                    <div className="scan" />
                </div>
                <div className="s2-hero-text">
                    <div className="title">{AntLocalization.translateText({ vi: 'AI đang phân tích…', en: 'AI is analyzing…', fr: 'L’IA analyse…', es: 'La IA está analizando…', ja: 'AI が解析中…', zh: 'AI 正在分析…', ko: 'AI 분석 중…', hi: 'AI विश्लेषण कर रहा है…', ar: 'الذكاء الاصطناعي يحلل…', id: 'AI menganalisis…' })}</div>
                    <div className="subline">
                        {fileName || AntLocalization.translateText({ vi: 'Tài liệu của bạn', en: 'Your document', fr: 'Votre document', es: 'Tu documento', id: 'Dokumen Anda', ja: 'あなたの文書', zh: '您的文档', ko: '내 문서', hi: 'आपका दस्तावेज़', ar: 'مستندك' })}
                        {fileSize ? ' · ' + (fileSize / 1024).toFixed(1) + ' KB' : ''}
                    </div>
                    <div className="timer">
                        <span className="dur">{mm}:{ss}</span>
                        <span>·</span>
                        <span>{AntLocalization.translateText({ vi: 'chế độ', en: 'mode', fr: 'mode', es: 'modo', id: 'mode', ja: 'モード', zh: '模式', ko: '모드', hi: 'मोड', ar: 'وضع' })} {modeLabel}</span>
                        {props.mode === 'Deep' && (
                            <Fragment>
                                <span>·</span>
                                <span>{AntLocalization.translateText({ vi: 'có thể mất 1-3 phút', en: 'may take 1-3 minutes', fr: 'peut prendre 1-3 minutes', es: 'puede tardar 1-3 minutos', id: 'bisa memakan 1-3 menit', ja: '1-3 分かかる場合あり', zh: '可能需要 1-3 分钟', ko: '1-3분 걸릴 수 있음', hi: '1-3 मिनट लग सकते हैं', ar: 'قد يستغرق 1-3 دقائق' })}</span>
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
